import { useEffect, useRef } from 'react';
import { testimonials } from '@/mocks/homeData';

export default function Testimonial() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in-up');
            entry.target.classList.remove('opacity-0');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full py-20 md:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="reveal opacity-0 inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-widest text-foreground-600 border border-foreground-300 rounded-full uppercase">
            Premium Benefits
          </span>
          <h2 className="reveal opacity-0 font-heading text-4xl md:text-5xl font-semibold text-foreground-900 mb-4 text-balance">
            프리미엄 혜택
          </h2>
          <p className="reveal opacity-0 text-foreground-600 text-lg md:text-xl max-w-2xl mx-auto">
            장기일반민간임대주택만의 특별한 혜택을 확인해보세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className="reveal opacity-0 relative flex flex-col md:flex-row rounded-2xl overflow-hidden bg-foreground-950"
              style={{ animationDelay: `${i * 200}ms` }}
            >
              <div className="relative w-full md:w-2/5 aspect-[4/3] md:aspect-auto md:min-h-[300px] overflow-hidden">
                <img
                  src={t.image}
                  alt={`${t.name} 혜택 안내`}
                  className="w-full h-full object-cover object-top"
                  width={400}
                  height={600}
                />
              </div>
              <div className="flex-1 flex flex-col justify-center p-6 md:p-8 lg:p-10">
                <div className="text-accent-400 text-5xl md:text-6xl font-heading leading-none mb-4">
                  &ldquo;
                </div>
                <p className="text-background-50 text-lg md:text-xl leading-relaxed mb-6">
                  {t.quote}
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-accent-500/20 flex items-center justify-center text-accent-400 text-base font-semibold">
                    {t.name[0]}
                  </div>
                  <div>
                    <p className="text-background-50 text-base font-semibold">{t.name}</p>
                    <p className="text-background-400 text-sm">{t.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}